import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { UserService } from 'src/app/core/services/user.services';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent implements OnInit {
  public form: UntypedFormGroup;
  public checking: boolean;
  public confirmed: boolean;
  public deletingAccount: boolean;
  public passwordType: string = 'password';

  constructor(
    private dialogRef: MatDialogRef<DeleteAccountComponent>,
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private notifications: NotificationService
  ) {}

  ngOnInit() {
    this.checking = true;
    this.confirmed = false;
    this.deletingAccount = false;

    this.form = this.fb.group({
      password: [null, Validators.required]
    });
    this.form.controls['password'].valueChanges
      .pipe(debounceTime(150))
      .subscribe((value) => (this.checking = value ? false : true));
  }

  togglePassword(): void {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }

  deleteAccount() {
    this.deletingAccount = true;
    this.checking = true;
    this.userService
      .deleteAccount(this.form.get('password').value)
      .then((response) => {
        this.notifications.showSuccess(response);
        this.dialogRef.close(true);
      })
      .catch((error) => {
        let messageError =
          error == 'Ocurrió un error inesperado.'
            ? 'En estos momentos no es posible eliminar la cuenta. Por favor, reintente mas tarde.'
            : error;
        this.checking = true;
        this.notifications.showError(messageError);
        this.form.reset();
        this.dialogRef.close(false);
      });
  }
}
